<div id="settings-tabs">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (link of links; track link.id) {
      @if (link.upgrade?.()) {
        <a mat-tab-link
          [id]="link.id"
          (click)="upgradePlan()"
          [active]="isLinkActive(link.route)"
        >
          {{link.name}}
          <mat-icon class="small tw-ml-2" svgIcon="requires-upgrade" id="company-licenses-requires-upgrade"></mat-icon>
        </a>
      } @else if (link.shown()) {
        <a mat-tab-link
          [id]="link.id"
          [uiSref]="link.route"
          [active]="isLinkActive(link.route)"> {{link.name}} </a>
      }
    }
  </nav>
  <mat-tab-nav-panel #tabPanel>
    <div ui-view></div>
  </mat-tab-nav-panel>
</div>